// | ------------------------------------------------------------------------
// | GSAP Scroll Animations - Project Cards
// | ------------------------------------------------------------------------

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// | ------------------------------------------------------------------------

//Register ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

// | ------------------------------------------------------------------------

// Section
const projectsSection = document.querySelector(".home-projects-section");

var project1 = document.querySelector(
  ".home-projects .project-item:first-child"
);
var project2 = document.querySelector(
  ".home-projects .project-item:nth-child(2)"
);
var project3 = document.querySelector(
  ".home-projects .project-item:nth-child(3)"
);

// | ------------------------------------------------------------------------


function projectCards(showMarkers) {
  // Get height of the intro text
  const projectsIntroHeight = document.querySelector(
    ".home-projects-intro"
  ).offsetHeight + "px";

  // Get height of a project
  //const projectHeight = getComputedStyle(
  //  document.querySelector(".project-item")
  //).getPropertyValue("--project-height");

  // Calculate the min height we need before switching form static layout
  //const projectsHeight = parseInt(projectHeight) + 80 + "px";

  // Calculate the min height we need before switching form static layout
  const projectsHeight = document.querySelector(
    ".home-projects"
  ).offsetHeight + "px"

  // Calculate the min height we need before switching target to entire section
  const projectsOuterWrapperHeight =
    parseInt(projectsIntroHeight) + parseInt(projectsHeight) + 114 + "px";

  let matchMedia = gsap.matchMedia();

  matchMedia.add(
    {
      noTrigger: "(max-height: " + projectsHeight + ")",
      innerTrigger:
        "(min-height: " +
        projectsHeight +
        ") and (max-height:" +
        projectsOuterWrapperHeight +
        ")",
      outerTrigger: "(min-height: " + projectsOuterWrapperHeight + ")",
    },
    (context) => {
      let { noTrigger } = context.conditions;
      let { innerTrigger, outerTrigger } = context.conditions;

      if (noTrigger) {
        // Use static layout
        projectsSection.classList.add("static");
      } else {

        //console.log("intro-height:" + projectsIntroHeight + "\n" + "project-height" +  projectsHeight + "\n" + "outer-wrapper-height:" + projectsOuterWrapperHeight + "\n" + "window-height:" + window.innerHeight )

        let homeProjects = gsap.timeline({
          paused: "true",
          scrollTrigger: {
            trigger: ".home-projects-wrapper",
            /*
            trigger: innerTrigger
              ? ".home-projects-wrapper"
              : ".home-projects-section", 
            */         
            start: "center center",
            end: "+=3000",
            //end: "bottom bottom",
            pinReparent: true,
            pin: ".homepage-trigger",   
            pinnedContainer: ".homepage-trigger",          
            markers: showMarkers,
            scrub: true,
            //snap: [0, 0.5, 1],
            snap: {
              snapTo: [0, 0.5, 1],
              duration: {min: 0.25, max: 0.75}, // the snap animation should be at least 0.25 seconds, but no more than 0.75 seconds (determined by velocity)
              //duration: {min: 0, max: 0.15},
              delay: 0, //.125, // wait 0.125 seconds from the last scroll event before doing the snapping
              ease: "power1.inOut" // the ease of the snap animation ("power3" by default)
            },              
            id: "home-projects",
          },
        });

        gsap.set(".home-projects .project-item", { position: "absolute" });

        gsap.set(project1, {zIndex: 1, y: 0});
        gsap.set(project2, {zIndex: 2, y: projectsHeight});
        gsap.set(project3, {zIndex: 3, y: projectsHeight});


        homeProjects
 
          // First item leaves
          .to(project1,{y: projectsHeight, rotate: 6, scale: .8, duration: 1.5, ease: "power2.out",}, .5)
          
          // Second item enters
          .to(project2,{y: 0, duration: 1.5, ease: "power2.in",}, "<-=1")

          // Second item leaves
          .to(project2,{y: projectsHeight, rotate: 6, scale: .8, duration: 1.5, ease: "power2.out"}, 2.5) 
          
          // Third item enters
          .to(project3,{y: 0, duration: 1.5, ease: "power2.in",}, "<-=1")       

      }
    }
  );
}

export { projectCards };
